import PDFServicePay from "../../../../src/pages/pricing/pay-as-you-go.md";
import PDFServiceVolume from "../../../../src/pages/pricing/volume-pricing.md";
import * as React from 'react';
export default {
  PDFServicePay,
  PDFServiceVolume,
  React
};